import {combineReducers} from 'redux';
import customersListReducer from './customersListReducer';
import filtersReducer from './filtersReducer';

// views
export default combineReducers({
  customersList: customersListReducer,
  filters: filtersReducer,
});
